import React from 'react';
import classnames from 'classnames';

// Hooks
import useContextMenu from './use-context-menu';

// Components
import { Portal } from '../portal/Portal';
import { WpContainer } from '../container';

// Styles
import './WpContextMenu.scss';

type Props = {
  children: React.ReactNode;
  menu: React.ReactNode;
  openClassName?: string;
};

const WpContextMenu = ({ children, menu, openClassName = 'context-open' }: Props) => {
  const { open, setOpen, points, setPoints } = useContextMenu();

  const baseClassName = 'WpContextMenu';

  return (
    <>
      <div
        className={baseClassName}
        onContextMenu={e => {
          e.preventDefault();
          setOpen(true);
          setPoints({
            x: e.pageX,
            y: e.pageY,
          });
        }}
      >
        {React.Children.map(children, (child: React.ReactElement<any>) => {
          return React.cloneElement(child, {
            className: classnames(child.props?.className, open ? openClassName : ''),
            // isActive: open,
          });
        })}
      </div>
      {open && (
        <Portal>
          <div className={`${baseClassName}__menu`} style={{ top: points.y, left: points.x }}>
            <WpContainer>{menu}</WpContainer>
          </div>
        </Portal>
      )}
    </>
  );
};

export default WpContextMenu;
